import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

export const useIsAuthorizedToBuyGems = () => {
  const { isAndroidApp } = useIsMobileApp();
  const {
    flags: { useDisableAndroidBuyGems = false },
  } = useFeatureFlags();
  if (isAndroidApp) {
    return !useDisableAndroidBuyGems;
  }
  return true;
};
